export default function Hero() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="top" className="relative -mt-16 md:-mt-[72px] flex min-h-[640px] w-full items-center overflow-hidden md:min-h-[680px]">
      {/* 背景图 */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20sunny%20spring%20travel%20holiday%20scene%20with%20palm%20leaves%20suitcases%20balloons%20and%20a%20steaming%20food%20stall%2C%20vibrant%20tangerine%20orange%20fresh%20green%20and%20soft%20cream%20melon%20color%20palette%2C%20playful%20festive%20flat%20cartoon%20style%2C%20clean%20minimal%20composition%2C%20high%20detail&width=1600&height=900&seq=hero-wuyi&orientation=landscape"
          alt="五一假期热点与出游主题插画背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-900/45 to-background-950/70"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-5xl px-4 pt-24 pb-16 text-center md:px-6 md:pt-28">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm text-background-50 backdrop-blur-sm">
          <i className="ri-calendar-check-line text-accent-300"></i>
          五一假期 · 全网热点持续更新中
        </span>

        <h1 className="mt-6 font-heading text-4xl leading-tight text-background-50 md:text-6xl md:leading-tight">
          五一爆料，
          <span className="text-accent-300">小长假大瓜</span>
          <br className="hidden md:block" />
          一网打尽
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
          从网络热议到现场见闻，这里汇总五一假期期间的热点事件与热门话题。
          话题热榜、热梗盘点、出游见闻一站看全，帮你快速掌握假期里的大瓜和新闻盘点，
          <span className="font-medium text-accent-200">吃瓜不迷路</span>。
        </p>

        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <button
            type="button"
            onClick={() => scrollTo('#headlines')}
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 rounded-full bg-primary-500 px-7 py-3 text-base font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            开始吃瓜
            <i className="ri-arrow-down-line"></i>
          </button>
          <button
            type="button"
            onClick={() => scrollTo('#hotlist')}
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 rounded-full border border-background-50/40 bg-background-50/10 px-7 py-3 text-base font-medium text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20"
          >
            看话题热榜
            <i className="ri-fire-line"></i>
          </button>
        </div>

        {/* 数据速览 */}
        <div className="mx-auto mt-12 grid max-w-2xl grid-cols-3 divide-x divide-background-50/20 rounded-2xl bg-background-50/10 py-5 backdrop-blur-sm">
          {[
            { num: '24+', label: '热点头条收录' },
            { num: '48', label: '话题持续上榜' },
            { num: '1200w', label: '全网讨论声量' },
          ].map((s) => (
            <div key={s.label} className="px-2 text-center">
              <div className="font-heading text-2xl text-accent-300 md:text-3xl">{s.num}</div>
              <div className="mt-1 text-xs text-background-100/90 md:text-sm">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}